export default "__VITE_ASSET__Btc20JBP__"